import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ReportService } from "src/app/services/report.service";
import { QueryExecutorDetailModel } from "src/app/model/QueryExecutorDetailModel";
import { AbstractControl, FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { DashboardDataEntryService } from "src/app/services/dashboardDataEntry.service";
import { DasboardDataEntryDetailModel } from "src/app/model/DasboardDataEntryDetailModel";
import { MatSelectChange } from "@angular/material/select";
import { DashboardNotifyModel } from "src/app/model/DashboardNotifyModel";
import { DashboardCallCenterNotifyModel } from "src/app/model/DashboardCallCenterNotifyModel";
import { DashboardLotteryNotifyModel } from "src/app/model/DashboardLotteryNotifyModel";
import { DashboardPostLotteryNotifyModel } from "src/app/model/DashboardPostLotteryNotifyModel";
import { DashboardMillWorkerScrutinyNotifyModel } from "src/app/model/DashboardMillWorkerScrutinyNotifyModel";
import { DashboardGrievanceNotifyModel } from "src/app/model/DashboardGrievanceNotifyModel";
import { DashboardAppPostLotteryEntriesNotifyModel } from "src/app/model/DashboardAppPostLotteryEntriesNotifyModel";
import { DashboardMillWorkerStatusNotifyModel } from "src/app/model/DashboardMillWorkerStatusNotifyModel";
import { colorSets } from "@swimlane/ngx-charts";

@Component({
  selector: "app-secure-dashboard-dataentry",
  templateUrl: "./dashboard-dataentry.component.html",
  styleUrls: ["./dashboard-dataentry.component.scss"],
})
export class DashboardDataEntryComponent implements OnInit {
    isLoading: boolean = false;
    dashboardKey: number;
    dashboardAppsKey: number;
    queryExecutorDetail: QueryExecutorDetailModel;
    dashboardDataEntryDetail: DasboardDataEntryDetailModel;
    submitDisabled: boolean;
    pageMode: string;
    dashboardAppName:  string;
    boards: {[key: number]: string};
    boardValue:string;
    dashboardNotifyDetail: DashboardNotifyModel;
    dashboardLotteryNotifyModel :DashboardLotteryNotifyModel;
    dashboardPostLotteryNotifyModel :DashboardPostLotteryNotifyModel;
    dashboardMillWorkerStatusNotifyModel :DashboardMillWorkerStatusNotifyModel;
    dashboardMillWorkerScrutinyNotifyModel :DashboardMillWorkerScrutinyNotifyModel;
    dashboardCallCenterNotifyModel :DashboardCallCenterNotifyModel;
    dashboardGrievanceNotifyModel : DashboardGrievanceNotifyModel;
    submittedFlag: boolean = false;
    generationDate:string;
    stakeHolder:string="STAKEHOLDER";

    form: FormGroup = new FormGroup({});

    dashboardDataEntryKey: number;
    constructor(private router: Router, private route: ActivatedRoute, 
        private reportService: ReportService,
        private dashboardDataEntryService: DashboardDataEntryService ) { }
    
    ngOnInit(): void {
        this.route.params.subscribe((params: Params) => {
            this.dashboardKey = +params["key"];
            this.dashboardDataEntryService.getDashboardDataEntryBykey(this.dashboardKey)
            .subscribe(res => {
                console.log("All Data",res);
                this.generationDate=res.generationDate
                this.dashboardLotteryNotifyModel=res.dashboardLotteryNotifyModel;
                this.dashboardPostLotteryNotifyModel=res.dashboardPostLotteryNotifyModel;
                this.dashboardMillWorkerScrutinyNotifyModel=res.dashboardMillWorkerScrutinyNotifyModel;
                this.dashboardCallCenterNotifyModel=res.dashboardCallCenterNotifyModel;
                this.dashboardGrievanceNotifyModel=res.dashboardGrievanceNotifyModel;
                this.dashboardMillWorkerStatusNotifyModel=res.dashboardMillWorkerStatusNotifyModel;

                this.form.patchValue({
                    dashboardKey: res.dashboardKey
                });

                //Lottery
                let dashboardAppLotteryNotifyList: FormArray = this.form.get('dashboardAppLotteryNotifyList') as FormArray;
                this.dashboardLotteryNotifyModel?.dashboardAppLotteryNotifyList.forEach((dashboardAppLotteryNotifyModel, i) => {
                    dashboardAppLotteryNotifyList.push(new FormGroup({
                        dashboardAppKey: new FormControl(dashboardAppLotteryNotifyModel?.dashboardAppKey),
                        comment: new FormControl(dashboardAppLotteryNotifyModel?.comment, [Validators.pattern(/^[a-zA-Z\s]+$/)]),
                        tableHeader: new FormControl(dashboardAppLotteryNotifyModel?.tableHeader),
                        list: new FormArray([])
                    }));
                    let frm = dashboardAppLotteryNotifyList['controls'][i];
                    console.log(i, dashboardAppLotteryNotifyModel.list, frm);

                    let list: FormArray = frm.get('list') as FormArray;
                    dashboardAppLotteryNotifyModel.list.forEach(dashboardAppLotteryEntriesNotifyModel => {
                        list.push(new FormGroup({
                            dashboardLotteryKey: new FormControl(dashboardAppLotteryEntriesNotifyModel?.dashboardLotteryKey),
                            lotteryCode: new FormControl(dashboardAppLotteryEntriesNotifyModel?.lotteryCode, [Validators.required]),
                            lotteryName: new FormControl(dashboardAppLotteryEntriesNotifyModel?.lotteryName, [Validators.required]),
                            tenementCount: new FormControl(dashboardAppLotteryEntriesNotifyModel?.tenementCount, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            applicationCount: new FormControl(dashboardAppLotteryEntriesNotifyModel?.applicationCount, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            emdPaidCount: new FormControl(dashboardAppLotteryEntriesNotifyModel?.emdPaidCount, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            participatingApplicantCount: new FormControl(dashboardAppLotteryEntriesNotifyModel?.participatingApplicantCount, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            rejectApplicantCount: new FormControl(dashboardAppLotteryEntriesNotifyModel?.rejectApplicantCount, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            winnerCount: new FormControl(dashboardAppLotteryEntriesNotifyModel?.winnerCount, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            waitlistCount: new FormControl(dashboardAppLotteryEntriesNotifyModel?.waitlistCount, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            vaccantTenement: new FormControl(dashboardAppLotteryEntriesNotifyModel?.vaccantTenement, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            highlightFiled: new FormControl(dashboardAppLotteryEntriesNotifyModel?.highlightFiled === 'Y'), 
                        }));
                    });  
                });
                
                //Post Lottery
                let dashboardAppPostLotteryNotifyList: FormArray = this.form.get('dashboardAppPostLotteryNotifyList') as FormArray;
                this.dashboardPostLotteryNotifyModel?.dashboardAppPostLotteryNotifyList.forEach((dashboardAppPostLotteryNotifyModel, i) => {
                    dashboardAppPostLotteryNotifyList.push(new FormGroup({
                        dashboardAppKey: new FormControl(dashboardAppPostLotteryNotifyModel?.dashboardAppKey),
                        comment: new FormControl(dashboardAppPostLotteryNotifyModel?.comment),
                        tableHeader: new FormControl(dashboardAppPostLotteryNotifyModel?.tableHeader),
                        list: new FormArray([])
                    }));
                    let frm = dashboardAppPostLotteryNotifyList['controls'][i];
                    console.log(i, dashboardAppPostLotteryNotifyModel.list, frm);

                    let list: FormArray = frm.get('list') as FormArray;
                    dashboardAppPostLotteryNotifyModel.list.forEach(dashboardAppPostLotteryEntriesNotifyModel => {
                        list.push(new FormGroup({
                            dashboardPostLotteryKey: new FormControl(dashboardAppPostLotteryEntriesNotifyModel?.dashboardPostLotteryKey),
                            lotteryCode: new FormControl(dashboardAppPostLotteryEntriesNotifyModel?.lotteryCode, [Validators.required]),
                            lotteryName: new FormControl(dashboardAppPostLotteryEntriesNotifyModel?.lotteryName, [Validators.required]),
                            tenementCount: new FormControl(dashboardAppPostLotteryEntriesNotifyModel?.tenementCount, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            loiPublishedCount: new FormControl(dashboardAppPostLotteryEntriesNotifyModel?.loiPublishedCount, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            acceptedTenementCount: new FormControl(dashboardAppPostLotteryEntriesNotifyModel?.acceptedTenementCount, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            surrenderTenementCount: new FormControl(dashboardAppPostLotteryEntriesNotifyModel?.surrenderTenementCount, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            polPublishedCount: new FormControl(dashboardAppPostLotteryEntriesNotifyModel?.polPublishedCount, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            partialInstallmentReceiptCount: new FormControl(dashboardAppPostLotteryEntriesNotifyModel?.partialInstallmentReceiptCount, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            fullInstallmentReceiptCount: new FormControl(dashboardAppPostLotteryEntriesNotifyModel?.fullInstallmentReceiptCount, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            totalAmountReceived: new FormControl(dashboardAppPostLotteryEntriesNotifyModel?.totalAmountReceived,[Validators.required,Validators.pattern(/^\d+(\.\d+)?$/)]),
                            appointmentBookCount: new FormControl(dashboardAppPostLotteryEntriesNotifyModel?.appointmentBookCount, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            allotmentPublishedCount: new FormControl(dashboardAppPostLotteryEntriesNotifyModel?.allotmentPublishedCount, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            possessionPublishedCount: new FormControl(dashboardAppPostLotteryEntriesNotifyModel?.possessionPublishedCount, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            agreementDoneCount: new FormControl(dashboardAppPostLotteryEntriesNotifyModel?.agreementDoneCount, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            possessionCompletedCount: new FormControl(dashboardAppPostLotteryEntriesNotifyModel?.possessionCompletedCount, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            highlightFiled: new FormControl(dashboardAppPostLotteryEntriesNotifyModel?.highlightFiled === 'Y'), 
                        }));
                    });  
                });
            
                
                //Call Center
                let dashboardAppCallCenterNotifyList: FormArray = this.form.get('dashboardAppCallCenterNotifyList') as FormArray;
                this.dashboardCallCenterNotifyModel?.dashboardAppCallCenterNotifyList.forEach((dashboardAppCallCenterNotifyModel, i) => {
                    dashboardAppCallCenterNotifyList.push(new FormGroup({
                        dashboardAppKey: new FormControl(dashboardAppCallCenterNotifyModel?.dashboardAppKey),
                        comment: new FormControl(dashboardAppCallCenterNotifyModel?.comment),
                        tableHeader: new FormControl(dashboardAppCallCenterNotifyModel?.tableHeader),
                        list: new FormArray([])
                    }));
                    let frm = dashboardAppCallCenterNotifyList['controls'][i];

                    let list: FormArray = frm.get('list') as FormArray;
                    dashboardAppCallCenterNotifyModel.list.forEach(dashboardAppCallCenterEntriesNotifyModel => {
                        list.push(new FormGroup({
                            dashboardCallCenterKey: new FormControl(dashboardAppCallCenterEntriesNotifyModel?.dashboardCallCenterKey),
                            boardName: new FormControl(dashboardAppCallCenterEntriesNotifyModel?.boardName, [Validators.required]),
                            callsReceived: new FormControl(dashboardAppCallCenterEntriesNotifyModel?.callsReceived, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            callsAnswered: new FormControl(dashboardAppCallCenterEntriesNotifyModel?.callsAnswered, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            callsMissed: new FormControl(dashboardAppCallCenterEntriesNotifyModel?.callsMissed, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            registration: new FormControl(dashboardAppCallCenterEntriesNotifyModel?.registration, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            schemeEnquiry: new FormControl(dashboardAppCallCenterEntriesNotifyModel?.schemeEnquiry, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            documentEnquiry: new FormControl(dashboardAppCallCenterEntriesNotifyModel?.documentEnquiry, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            otpAndDigiLocker: new FormControl(dashboardAppCallCenterEntriesNotifyModel?.otpAndDigiLocker, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            technicalEnquiry: new FormControl(dashboardAppCallCenterEntriesNotifyModel?.technicalEnquiry, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            highlightFiled: new FormControl(dashboardAppCallCenterEntriesNotifyModel?.highlightFiled === 'Y'), 
                        }));
                    });  
                });

                //Grievancer
                let dashboardAppGrievanceNotifyList: FormArray = this.form.get('dashboardAppGrievanceNotifyList') as FormArray;
                this.dashboardGrievanceNotifyModel?.dashboardAppGrievanceNotifyList.forEach((dashboardAppGrievanceNotifyModel, i) => {
                    dashboardAppGrievanceNotifyList.push(new FormGroup({
                        dashboardAppKey: new FormControl(dashboardAppGrievanceNotifyModel?.dashboardAppKey),
                        comment: new FormControl(dashboardAppGrievanceNotifyModel?.comment),
                        tableHeader: new FormControl(dashboardAppGrievanceNotifyModel?.tableHeader),
                        list: new FormArray([])
                    }));
                    let frm = dashboardAppGrievanceNotifyList['controls'][i];

                    let list: FormArray = frm.get('list') as FormArray;
                    dashboardAppGrievanceNotifyModel.list.forEach(dashboardAppGrievanceEntriesNotifyModel => {
                        list.push(new FormGroup({
                            dashboardGrievanceKey: new FormControl(dashboardAppGrievanceEntriesNotifyModel?.dashboardGrievanceKey),
                            boardName: new FormControl(dashboardAppGrievanceEntriesNotifyModel?.boardName, [Validators.required]),
                            numberOfGrivenance: new FormControl(dashboardAppGrievanceEntriesNotifyModel?.numberOfGrivenance, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            closed: new FormControl(dashboardAppGrievanceEntriesNotifyModel?.closed, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            pending: new FormControl(dashboardAppGrievanceEntriesNotifyModel?.pending, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            registration: new FormControl(dashboardAppGrievanceEntriesNotifyModel?.registration, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            applications: new FormControl(dashboardAppGrievanceEntriesNotifyModel?.applications, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            paymnet: new FormControl(dashboardAppGrievanceEntriesNotifyModel?.paymnet, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            highlightFiled: new FormControl(dashboardAppGrievanceEntriesNotifyModel?.highlightFiled === 'Y'), 
                        }));
                    });  
                });

                //Mill Worker Status
                let dashboardAppMillWorkerStatusNotifyList: FormArray = this.form.get('dashboardAppMillWorkerStatusNotifyList') as FormArray;
                this.dashboardMillWorkerStatusNotifyModel?.dashboardAppMillWorkerStatusNotifyList.forEach((dashboardAppMillWorkerStatusNotifyModel, i) => {
                    dashboardAppMillWorkerStatusNotifyList.push(new FormGroup({
                        dashboardAppKey: new FormControl(dashboardAppMillWorkerStatusNotifyModel?.dashboardAppKey),
                        comment: new FormControl(dashboardAppMillWorkerStatusNotifyModel?.comment),
                        tableHeader: new FormControl(dashboardAppMillWorkerStatusNotifyModel?.tableHeader),
                        list: new FormArray([])
                    }));
                    let frm = dashboardAppMillWorkerStatusNotifyList['controls'][i];

                    let list: FormArray = frm.get('list') as FormArray;
                    dashboardAppMillWorkerStatusNotifyModel.list.forEach(dashboardAppMillWorkerStatusEntriesNotifyModel => {
                        list.push(new FormGroup({
                            dashboardMillWorkerStatusKey: new FormControl(dashboardAppMillWorkerStatusEntriesNotifyModel?.dashboardMillWorkerStatusKey),
                            process: new FormControl(dashboardAppMillWorkerStatusEntriesNotifyModel?.process , [Validators.required]),
                            dailyCount: new FormControl(dashboardAppMillWorkerStatusEntriesNotifyModel?.dailyCount, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            cumulativeCount: new FormControl(dashboardAppMillWorkerStatusEntriesNotifyModel?.cumulativeCount, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            highlightFiled: new FormControl(dashboardAppMillWorkerStatusEntriesNotifyModel?.highlightFiled === 'Y'),
                        }));
                    });  
                });

                //Mill Worker Scrutiny
                let dashboardAppMillWorkerScrutinyNotifyList: FormArray = this.form.get('dashboardAppMillWorkerScrutinyNotifyList') as FormArray;
                console.log("test Scrutiny",this.form.get('dashboardAppMillWorkerScrutinyNotifyList') as FormArray);
                this.dashboardMillWorkerScrutinyNotifyModel?.dashboardAppMillWorkerScrutinyNotifyList.forEach((dashboardAppMillWorkerScrutinyNotifyModel, i) => {
                    dashboardAppMillWorkerScrutinyNotifyList.push(new FormGroup({
                        dashboardAppKey: new FormControl(dashboardAppMillWorkerScrutinyNotifyModel?.dashboardAppKey),
                        comment: new FormControl(dashboardAppMillWorkerScrutinyNotifyModel?.comment),
                        tableHeader: new FormControl(dashboardAppMillWorkerScrutinyNotifyModel?.tableHeader),
                        list: new FormArray([])
                    }));
                    let frm = dashboardAppMillWorkerScrutinyNotifyList['controls'][i];

                    let list: FormArray = frm.get('list') as FormArray;
                    dashboardAppMillWorkerScrutinyNotifyModel.list.forEach(dashboardAppMillWorkerScrutinyEntriesNotifyModel => {
                        list.push(new FormGroup({
                            dashboardMillWorkerScrutinyKey: new FormControl(dashboardAppMillWorkerScrutinyEntriesNotifyModel?.dashboardMillWorkerScrutinyKey),
                            process: new FormControl(dashboardAppMillWorkerScrutinyEntriesNotifyModel?.process , [Validators.required]),
                            dailyCount: new FormControl(dashboardAppMillWorkerScrutinyEntriesNotifyModel?.dailyCount, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
                            highlightFiled: new FormControl(dashboardAppMillWorkerScrutinyEntriesNotifyModel?.highlightFiled === 'Y'),
                        }));
                    });  
                });

               
                

            });

        });
        
        this.form = new FormGroup({   
            dashboardKey: new FormControl(null),         
            dashboardAppLotteryNotifyList: new FormArray([]),
            dashboardAppPostLotteryNotifyList: new FormArray([]),
            dashboardAppCallCenterNotifyList: new FormArray([]),
            dashboardAppGrievanceNotifyList : new FormArray([]),
            dashboardAppMillWorkerScrutinyNotifyList: new FormArray([]),
            dashboardAppMillWorkerStatusNotifyList: new FormArray([]),
        });
    }

    get dashboardAppLotteryNotifications() {
        return this.form.get('dashboardAppLotteryNotifyList')['controls'];
    }
    get dashboardAppPostLotteryNotifications() {
        return this.form.get('dashboardAppPostLotteryNotifyList')['controls'];
    }
    get dashboardAppCallCenterNotifications() {
        return this.form.get('dashboardAppCallCenterNotifyList')['controls'];
    }
    get dasboardAppMillWorkerScrutinyNotifications() {
        return this.form.get('dashboardAppMillWorkerScrutinyNotifyList')['controls'];
    }
    get dasboardAppMillWorkerStatusNotifications() {
        return this.form.get('dashboardAppMillWorkerStatusNotifyList')['controls'];
    }
    get dashboardAppGrievanceNotifications() {
        return this.form.get('dashboardAppGrievanceNotifyList')['controls'];
    }

    addCallcenterRecord() {
        let frmArray: FormArray = this.form.get('dashboardAppCallCenterNotifyList')['controls'][0].get('list') as FormArray;
        frmArray.push(new FormGroup({
            dashboardCallCenterKey: new FormControl(null),
            boardName: new FormControl(null, [Validators.required]),
            callsReceived: new FormControl(null, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
            callsAnswered: new FormControl(null, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
            callsMissed: new FormControl(null, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
            registration: new FormControl(null, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
            schemeEnquiry: new FormControl(null, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
            documentEnquiry: new FormControl(null, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
            otpAndDigiLocker: new FormControl(null, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
            technicalEnquiry: new FormControl(null, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
        }));
    }

    deleteCallCenter(i: number) {
        let frmArray: FormArray = this.form.get('dashboardAppCallCenterNotifyList')['controls'][0].get('list') as FormArray;
        frmArray.removeAt(i);
    }

    addMillWorkerStatusRecord(){
        let frmArray: FormArray = this.form.get('dashboardAppMillWorkerStatusNotifyList')['controls'][0].get('list') as FormArray;
        frmArray.push(new FormGroup({
            dashboardMillWorkerStatusKey: new FormControl(null),
            process: new FormControl(null, [Validators.required]),
            dailyCount: new FormControl(null, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
            cumulativeCount: new FormControl(null, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
        }));
    }

    deleteMillWorkerStatus(i: number) {
        let frmArray: FormArray = this.form.get('dashboardAppMillWorkerStatusNotifyList')['controls'][0].get('list') as FormArray;
        frmArray.removeAt(i);
    }
    
    addMillWorkerScrutinyRecord(){
        let frmArray: FormArray = this.form.get('dashboardAppMillWorkerScrutinyNotifyList')['controls'][0].get('list') as FormArray;
        frmArray.push(new FormGroup({
            dashboardMillWorkerScrutinyKey: new FormControl(null),
            process: new FormControl(null, [Validators.required]),
            dailyCount: new FormControl(null, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
        }));
    }

    deleteMillWorkerScrutiny(i: number) {
        let frmArray: FormArray = this.form.get('dashboardAppMillWorkerScrutinyNotifyList')['controls'][0].get('list') as FormArray;
        frmArray.removeAt(i);
    }

    addGrievanceRecord(){
        let frmArray: FormArray = this.form.get('dashboardAppGrievanceNotifyList')['controls'][0].get('list') as FormArray;
        frmArray.push(new FormGroup({
            dashboardGrievanceKey: new FormControl(null),
            boardName: new FormControl(null, [Validators.required]),
            numberOfGrivenance: new FormControl(null, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
            closed: new FormControl(null, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
            pending: new FormControl(null, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
            registration: new FormControl(null, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
            applications: new FormControl(null, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
            paymnet: new FormControl(null, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
        }));
    }

    deleteGrievance(i: number) {
        let frmArray: FormArray = this.form.get('dashboardAppGrievanceNotifyList')['controls'][0].get('list') as FormArray;
        frmArray.removeAt(i);
    }

    submitForm() {
        this.submittedFlag = true;
        console.log("submitForm",this.form.value);
        console.log("this.dashboardKey ravi",this.dashboardKey)
        if (this.form.valid) {
            this.dashboardDataEntryService.submitData(this.dashboardKey, this.form.value).subscribe(
                response=>{
                    if(response.status === 'SUCCESS') {
                        this.dashboardDataEntryService.successToast("Saved successfully");
                        this.ngOnInit();
                        this.generateDashboardReport(this.stakeHolder,this.generationDate);
                    }
                    else {
                        this.dashboardDataEntryService.errorToast(response?.errorMessage);//    
                    }
                },
                error =>{
                    this.dashboardDataEntryService.errorToast(error?.error?.message||error?.message);//
                }
            );
           
        }
    }
    
    generateDashboardReport(type:string,generationDate:string){
        console.log("++++++++++++++",this.stakeHolder,this.generationDate);
        
        this.dashboardDataEntryService.generateDashboardReport(this.stakeHolder,this.generationDate).subscribe(
          (res) => {
            this.isLoading = false;           
            // if (res.status === "SUCCESS") {
            //   const base64 = res;
            //   this.downloadFile(base64?.data, base64?.fileName);
            // } else {
            //     this.dashboardDataEntryService.errorToast(res?.error?.message||res?.message);
            // }
          },
          (error) => {
            this.isLoading = false;
            this.dashboardDataEntryService.errorToast(error?.error?.message||error?.message);
          }
        );
      }
    
      downloadFile(base64File: string, fileName: string) {
        const byteArray = new Uint8Array(
          atob(base64File)
            .split("")
            .map((char) => char.charCodeAt(0))
        );
    
        let blob = new Blob([byteArray], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(url);
        a.remove();
      }
    
}